module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"etd":"Departure","from":"From","noTripsFound":"No trips have been generated yet","removeConnection":"Remove connection","to":"To","tripNumber":"Trip"},"no":{"etd":"Avgang","from":"Fra","noTripsFound":"Ingen turer har blitt generert enda","removeConnection":"Fjern kobling","to":"Til","tripNumber":"Tur"}}')
  delete Component.options._Ctor
}
